import React from 'react'
import './Skills.css'

const Skills = () => {
  return (
    <div className='Skills'> 
      <h2 className='Skills__header'>Skills</h2>   
      <div className='Skills__line'></div> 
      <ul className='Skills__list'>
        <li className='Skills__list_item'>
          <span style={{textDecoration: 'underline'}}>Computer literacy</span>
          <span>: HTML, CSS (SCSS), JavaScript, TypeScript, Git, WebPack, React, Angular, Electron, Redux Toolkit, Canvas, Docker, Node.js, NestJS, TypeORM,
            MongoDB, PostgreSQL, GraphQL (Apollo Server),  AutoCAD, CorelDRAW, Photoshop, Maxon Cinema 4d, SolidWorks, Ansys Mechanical;
          </span>
        </li>
        <li className='Skills__list_item'>
          <span>Native Russian and Belarusian;</span>
        </li>
        <li className='Skills__list_item'>
          <span>Currently my English is the A2 level;</span>
        </li>
        <li className='Skills__list_item'>
          <span style={{textDecoration: 'underline'}}>Driving license</span>
          <span>: Category B;</span>
        </li>                        
        <li className='Skills__list_item'>
          <span style={{textDecoration: 'underline'}}>Hobbies</span>
          <span>: running, skating, judo, 3d modeling and printing, bonsai.</span>
        </li>
      </ul>
    </div>
  )
}

export default Skills